module Overview

open Client
open Fable.React
open Fable.React.Props
open Fulma
open Model
open PortalLibs.Client.Components.Progress
open Shared

let view contractSettings (contract: Contract)=
  let formatAmount floatOpt =
    match floatOpt with
    | None -> nothing
    | Some float -> float |> DisplayNumber.AsCurrency.stdStr
  let formatPercent floatOpt =
    match floatOpt with
    | None -> nothing
    //| Some per -> sprintf "%s%%" (System.Math.Round((per*100.0), 2).ToString()) |> str
    | Some per -> div [ Style [ Display DisplayOptions.Flex; JustifyContent "flex-end"; PaddingRight "7px" ] ]
                      [ CircleProgress {| percent = (per * 100.0); border = 0.0; key = contract.Id.ToString() |}   ]
  let tabHr () =
    [
      //tr [ ] [ td [ Style [ Height "25px" ] ] [ ] ]
      tr [  ] [
        td [ ] [ ]
        td [ ColSpan 5; Style [ BorderWidth "0 0 2px 0" ] ] [ ] ]
      tr [ ] [ td [ ] [ ] ]
    ]
  let tdStyle = Style [ TextAlign TextAlignOptions.Right; Padding ".2em 0.75em" ]
  let pctStyle = Style [
    //Display DisplayOptions.Flex; JustifyContent "center"
    TextAlign TextAlignOptions.Right
    VerticalAlign "middle"
    PaddingTop "0"
    PaddingBottom "0"
    ]
  let table =
    Table.table [
        Table.CustomClass "overview-table"
        Table.Props [ Style [ MarginLeft "auto"; MarginRight "auto"; MarginLeft "-10px" ] ]
        Table.IsHoverable ]
      [ thead [ ]
          [ tr [ ]
              [ th [ Style [ Width "185px" ] ] [ ]
                th [ Style [ TextAlign TextAlignOptions.Right; Width "100px" ] ] [ str "Original Contract" ]
                th [ Style [ TextAlign TextAlignOptions.Right; Width "100px" ] ] [ str "Current Contract" ]
                th [ Style [ TextAlign TextAlignOptions.Right; Width "125px" ] ] [ str "Billing & Cost Actual Cost" ]
                if contractSettings.Projections then
                  th [ Style [ VerticalAlign "middle"; TextAlign TextAlignOptions.Right; Width "110px" ] ] [ str "Projections" ]
                  th [ Style [ TextAlign TextAlignOptions.Right; Width "147px" ] ] [ str "Project Manager Projection" ]
              ] ]
        tbody [ ]
          [ yield tr [ Style [ Height "20px" ] ]
                [ td [ tdStyle ] [ strong [] [ str "Revenue" ] ]
                  td [ tdStyle ] [ contract.OCRev |> formatAmount ]
                  td [ tdStyle ] [ contract.CCRev |> formatAmount ]
                  td [ tdStyle ] [ contract.BCRev |> formatAmount ]
                  if contractSettings.Projections then
                    td [ tdStyle ] [ contract.PRev |> formatAmount ]
                    td [ tdStyle ] [ contract.PMPRev |> formatAmount ]
                ]
            yield tr [ ]
                [ td [ tdStyle ] [ strong [] [ str "PCOs" ] ]
                  td [ tdStyle ] [ nothing ]
                  td [ tdStyle ] [ contract.CCPCO |> formatAmount ]
                  td [ tdStyle ] [ nothing ]
                  if contractSettings.Projections then
                    td [ tdStyle ] [ contract.PPCO |> formatAmount ]
                    td [ tdStyle ] [ contract.PMPPCO |> formatAmount ]
                ]
            yield tr [ ]
                [ td [ tdStyle ] [ strong [] [ str "Revenue plus all PCO" ] ]
                  td [ tdStyle ] [ nothing ]
                  td [ tdStyle ] [ strong [] [
                    match contract.CCRev, contract.CCPCO with
                    | None, None -> yield nothing
                    | _, _ -> yield ((contract.CCRev |> Option.defaultValue 0.0) +
                                     (contract.CCPCO |> Option.defaultValue 0.0)) |> Some |> formatAmount ] ]
                  td [ tdStyle ] [ nothing ]
                  if contractSettings.Projections then
                    td [ tdStyle ] [ strong [] [
                      match contract.PRev, contract.PPCO with
                      | None, None -> yield nothing
                      | _, _ -> yield ((contract.PRev |> Option.defaultValue 0.0) +
                                       (contract.PPCO |> Option.defaultValue 0.0)) |> Some |> formatAmount ] ]
                    td [ tdStyle ] [ strong [] [ contract.PMPRevPlusAllPCO |> formatAmount ] ]
                ]
            yield! tabHr ()
            yield tr [ ]
                [ td [ tdStyle ] [ strong [] [ str contractSettings.OverviewSettings.CostsLabel ] ]
                  td [ tdStyle ] [ contract.OCCosts |> formatAmount ]
                  td [ tdStyle ] [ contract.CCCosts |> formatAmount ]
                  td [ tdStyle ] [ contract.BCCosts |> formatAmount  ]
                  if contractSettings.Projections then
                    td [ tdStyle ] [ contract.PCosts |> formatAmount ]
                    td [ tdStyle ] [ contract.PMPCosts |> formatAmount ]
                ]
            yield tr [ ]
                [ td [ tdStyle ] [ strong [] [ str contractSettings.OverviewSettings.ProfitLabel ] ]
                  td [ tdStyle ] [ contract.OCProfit |> formatAmount ]
                  td [ tdStyle ] [ contract.CCProfit |> formatAmount ]
                  td [ tdStyle ] [ contract.BCProfit |> formatAmount  ]
                  if contractSettings.Projections then
                    td [ tdStyle ] [ contract.PProfit |> formatAmount ]
                    td [ tdStyle ] [ contract.PMPProfit |> formatAmount ]
                ]
            yield! tabHr ()
            yield tr [ ]
                [ td [ pctStyle ] [ strong [] [ str contractSettings.OverviewSettings.GPPerLabel ] ]
                  td [ pctStyle ] [ contract.OCGPPercent |> formatPercent ]
                  td [ pctStyle ] [ contract.CCGPPercent |> formatPercent ]
                  td [ pctStyle ] [ contract.BCGPPercent |> formatPercent  ]
                  if contractSettings.Projections then
                    td [ pctStyle ] [ contract.PGPPercent |> formatPercent ]
                    td [ pctStyle ] [ contract.PMPGPPercent |> formatPercent ]
                  ]

            ] ]
  div [ Style [ PaddingBottom "30px"; PaddingTop "10px"; Display DisplayOptions.Flex; ] ] [
    div [ Style [ Width "0"; FlexGrow "1" ] ] []
    table
    div [ Style [ Width "0"; FlexGrow "3" ] ] []
  ]